export default "__VITE_ASSET__3f7e2f96__"